import { type UniqAppConfig, useKorintUniqConfig } from 'korint-sdk/react';
import { useEffect } from 'react';

function setTheme(colors: UniqAppConfig['colors']) {
  const root = document.querySelector(':root') as HTMLElement;
  const style = root.style;

  style.setProperty('--primary', colors.primary);
  style.setProperty('--secondary', colors.secondary);
  style.setProperty('--primary-foreground', colors.primaryForeground);
  style.setProperty('--secondary-foreground', colors.secondaryForeground);
}

export function SetTheme() {
  const { colors } = useKorintUniqConfig();

  useEffect(() => {
    setTheme(colors);
  }, [colors]);

  return null;
}
